import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IntervalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const DateContainer = styled.div`
  width: 95%;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ebebeb;
  border-radius: 50px;
  padding: 10px 11px;
  input[type='date'] {
    width: fit-content;
    margin: 0;
    padding: 0;
  }
  input[type='date']::-webkit-calendar-picker-indicator {
    opacity: 1;
    font-size: 1.3rem;
    transition: all ease 400ms;
    transform: scale(1);
    margin-left: 0;
  }
`;

export const DateInput = styled.input`
  outline: none;
  border: 0;
  background-color: none;
  font-weight: 400;
  font-size: 1rem;
  width: fit-content;

  input[type='date']::-webkit-inner-spin-button,
  input[type='date']::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`;

export const DateQuestionTitle = styled.h3`
  color: ${(props) => props.theme.colors.lightText};
  font-size: 0.9em;
  margin-right: 5px;
  font-weight: 400;
`;
